"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _cccisdTabletop = _interopRequireDefault(require("cccisd-tabletop"));
var _query = _interopRequireDefault(require("./query.graphql"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var deploymentsLogTable = function deploymentsLogTable() {
  var view = {
    query: _query["default"],
    rowKey: 'deploymentId',
    isAscentOrder: true,
    handle: 'deploymentsLog',
    columns: [{
      name: 'label',
      label: 'Deployment',
      filter: true,
      sort: true
    }, {
      name: 'assignment.label',
      label: 'Quest',
      filter: true,
      sort: true
    }, {
      name: 'assignment.group.group.label',
      label: 'Project',
      filter: true,
      sort: true
    }, {
      name: 'hash',
      label: 'Hash',
      filter: true,
      sort: true
    }, {
      name: 'endpoint',
      label: 'Custom URL',
      filter: true,
      sort: true,
      render: function render(_ref) {
        var value = _ref.value;
        return value ? '/survey/' + value : '';
      }
    }, {
      name: 'deploymentHandle',
      label: 'Handle',
      filter: true,
      sort: true
    }]
  };
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdTabletop["default"], {
    handle: "deploymentsLog",
    saveState: true,
    views: [{
      handle: 'deploymentsLog',
      title: 'Deployments Log',
      table: view
    }]
  }));
};
var _default = exports["default"] = {
  name: 'deploymentslog',
  title: 'Deployments Log',
  content: deploymentsLogTable()
};